import { Box } from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getBranchById } from "../../utilities/common";

function TableSection(props) {
    const {t} = useTranslation('deliveryAreaManagement');

    const PAGE_SIZE = 20;

    const zipCodeColumns = [
        {field: 'id', headerName: t('id'), hide: true},
        {field: 'zipcode', headerName: t('zip_code'), width: 200, headerAlign: 'center', align: 'center', flex: 1},
        {field: 'sorting_zone', headerName: t('sorting_zone'), width: 150, headerAlign: 'center', align: 'center', flex: 1},
        {
            field: 'city', 
            headerName: t('warehouse'), 
            width: 200, 
            headerAlign: 'center', 
            align: 'center',
            renderCell: (params) => (
                <div>{getBranchById(params.value)?.short_name}</div>
            ),
            flex: 1
        },
        {field: 'owner', headerName: t('airport'), width: 150, headerAlign: 'center', align: 'center', flex: 1},
        {field: 'route_no', headerName: t('service_no'), width: 150, headerAlign: 'center', align: 'center', flex: 1},
        {field: 'area', headerName: t('area'), width: 150, headerAlign: 'center', align: 'center', flex: 1},
        {field: 'price', headerName: t('price'), width: 150, headerAlign: 'center', align: 'center', flex: 1},
        {
            field: 'is_remote', 
            headerName: t('remote'), 
            width: 150, 
            headerAlign: 'center', 
            align: 'center', 
            flex: 1,
            renderCell: (params) => (
                <div>{params.value?t('Yes'):t('No')}</div>
            ),
        },
        {
            field: 'pattern_id', 
            headerName: t('pattern_id'), 
            width: 150, 
            headerAlign: 'center', 
            align: 'center', 
            flex: 1
        },
        {
            field: 'is_enabled', 
            headerName: t('status'), 
            width: 150, 
            headerAlign: 'center', 
            align: 'center', 
            flex: 1,
            renderCell: (params) => (
                <div
                    style={params.value?{color: 'white'}:{color: 'OrangeRed'}}
                >
                    {params.value?t('active'):t('inactive')}
                </div>
            ),
        }
    ];
    const zoneColumns = [
        {field: 'id', headerName: t('zone'), width: 200, headerAlign: 'center', align: 'center', flex: 1},
        {field: 'from_airport', headerName: t('depart_airport'), width: 150, headerAlign: 'center', align: 'center', flex: 1},
        {field: 'to_airport', headerName: t('destination_airport'), width: 150, headerAlign: 'center', align: 'center', flex: 1},
        {field: 'zone_type', headerName: t('zone_type'), width: 150, headerAlign: 'center', align: 'center', flex: 1},
        {
            field: 'is_active', 
            headerName: t('status'), 
            width: 150, 
            headerAlign: 'center', 
            align: 'center', 
            flex: 1,
            renderCell: (params) => (
                <div
                    style={params.value?{color: 'white'}:{color: 'OrangeRed'}}
                >
                    {params.value?t('active'):t('inactive')}
                </div>
            ),
        }
    ];

    const [columns, setColumns] = useState([]);

    const createRows = () => {
        if(props.type === 'zipCode') {
            if(props.allZipCodes.data?.length > 0) {
                return props.allZipCodes.data.map((row) => {
                    const {...rest} = row
                    return {...rest}
                })
            }
        } else {
            if(props.allZone.data?.length > 0) {
                return props.allZone.data.map((row) => {
                    const {zone_name, id, ...rest} = row
                    return {id: zone_name, temp: id, ...rest}
                })
            }
        }
        return [];
    }

    useEffect(() => {
        if(props.type === 'zipCode') {
            setColumns(zipCodeColumns);
        } else {
            setColumns(zoneColumns);
        }
    }, [props.type])

    return (
        <Box style={{margin: 0}}>
            <DataGrid
                columns={columns}
                rows={createRows() || []}
                pagination
                paginationMode="server"
                pageSize={PAGE_SIZE}
                alignItems="center"
                page={props.page - 1}
                rowsPerPageOptions={[PAGE_SIZE]}
                rowCount={props.type==='zipCode'?props.allZipCodes?.total:props.allZone?.total || 0}
                loading={props.isDataLoading}
                checkboxSelection
                disableSelectionOnClick
                onPageChange={(newPage) => {
                    props.setPage(newPage + 1);
                }}   
                onSelectionModelChange={(newSelection) => {
                    props.setSelectedItems(newSelection);
                }}
                style={{height: '80vh'}}
                onRowClick={(selectedRow) => props.handleRowClick(selectedRow)}
           />
        </Box>
    );
}
export default TableSection;